/**
 * Enforceable minimum output for KyberSwap trades. The application fee is a
 * fee (multiplied), never a slippage widening (added) — 2026plan §8.
 * quoteIsNetOfFee is determined by the gateway worker's chargeFeeBy config;
 * see the Task 0 investigation note in the commit that introduced this file.
 */
export function kyberMinimumAmountOut(
  quotedAmountOut: bigint,
  quoteIsNetOfFee: boolean,
  feeBps: bigint,
  slippageBps: bigint,
): bigint {
  if (quotedAmountOut < 0n || feeBps < 0n || feeBps > 10_000n || slippageBps < 0n || slippageBps > 10_000n) {
    throw new Error('invalid minimum-out inputs')
  }
  const net = quoteIsNetOfFee ? quotedAmountOut : (quotedAmountOut * (10_000n - feeBps)) / 10_000n
  return (net * (10_000n - slippageBps)) / 10_000n
}
